import React from 'react';

export function QuoteContent(props) {

    return (

        <div className={" py-3 rounded p-3 text-center my-5"}>
            {
                props.children.split(";").map((item, idx) => (

                    <>
                    {idx === 0 ?
                        <h5 className={"italic fw-bold mb-2 "}>
                            <i>"{item}"</i>
                        </h5>
                        :
                        <p className={ "text-muted"}>

                            - {item}
                        </p>
                    }
                    </>


                ))
            }

        </div>

    );

}